
import { defineComponent } from 'vue';

import { useStore } from 'vuex';

import ModalHeader from '@/modules/modals/components/ModalHeader.vue';
import ModalBody from '@/modules/modals/components/ModalBody.vue';
import ModalFooter from '@/modules/modals/components/ModalFooter.vue';
import ModalService from '@/modules/modals/services/modalService';
import { chunk } from 'lodash';
import utils from '@/utils/QSUtils';

export default defineComponent({
    components: { ModalHeader, ModalBody, ModalFooter },
    props: {
        sources: null,
    },
    data() {
        return {
            modal: null,
        };
    },
    setup() {
        const store = useStore();
        return {
            store,
        };
    },
    computed: {
        chunked() {
            const customArr = ['CV', 'UT', 'FF'];
            const sources = this.sources.cells.map(function (obj: any) {
                return obj.initials;
            });
            const sourcesArr = [...sources, ...customArr];
            const items = [];
            var k = 0;
            for (var i = 0; i < sourcesArr.length; i++) {
                var item = utils.initialDetails(sourcesArr[i]);
                if (item.name !== '') {
                    items[k] = item;
                    k++;
                }
            }
            return chunk(items, 3);
        },
    },
    mounted() {
        const modalElement = this.$refs.dataSourceLegend;
        this.modal = ModalService.initialize(modalElement, this);
        ModalService.size(modalElement, '600');
        ModalService.open(this.modal);
    },
    methods: {
        getClassForPill(initials: string) {
            return `d-inline-block mr-1 rounded initial-badge-${initials.toLowerCase()} source-${initials.toLowerCase()}`;
        },
        getStyleForDiv(): string {
            return `column-count:${this.chunked.length}`;
        },
    },
});
